import React from 'react'
import { createPortal } from 'react-dom'
import { Button, Heading, Text } from '../ui'

type AgendaAttentionModalProps = {
  message: string | null
  onClose: () => void
  /** id do título para aria-labelledby (padrão estável). */
  titleId?: string
}

/**
 * Alerta simples (Atenção) usado na agenda/triagem para bloqueios de horário/tolerância.
 */
export const AgendaAttentionModal: React.FC<AgendaAttentionModalProps> = ({
  message,
  onClose,
  titleId = 'agenda-attention-modal-title',
}) => {
  if (!message) return null

  return createPortal(
    <div
      className="fixed inset-0 z-[110] flex items-center justify-center bg-black/50 p-4"
      onMouseDown={(e) => {
        if (e.target === e.currentTarget) onClose()
      }}
    >
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby={titleId}
        className="bg-white dark:bg-gray-800 rounded-lg shadow-xl w-full max-w-md p-6 space-y-4"
        onMouseDown={(e) => e.stopPropagation()}
      >
        <Heading as="h3" size="2xl" id={titleId} className="text-gray-900 dark:text-white">
          Atenção
        </Heading>
        <Text size="sm" color="muted">
          {message}
        </Text>
        <div className="flex justify-end">
          <Button onClick={onClose}>Fechar</Button>
        </div>
      </div>
    </div>,
    document.body
  )
}
